// @flow
/* eslint-disable max-len,react/require-default-props */

import * as React from 'react';
import { SvgXml } from 'react-native-svg';
import {
    Platform,
} from 'react-native';

const styles = {
    first: {
        fill: 'none',
        stroke: '#0080b4',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: 1.5,
    },
};

const xml = `
       <svg xmlns="http://www.w3.org/2000/svg" width={15} height={15} viewBox="0 0 9.5 14.03">
            <title>moveDown</title>
            <g id="Layer_2">
                <g id="Layer_1-2">
                    <line x1="4.75" y1="0.75" x2="4.75" y2="13.28" style={styles.first} />
                    <line x1="4.75" y1="13.28" x2="8.75" y2="9.14" style={styles.first} />
                    <line x1="4.75" y1="13.28" x2="0.75" y2="9.14" style={styles.first} />
                </g>
            </g>
        </svg>
`;

const MoveDownIcon = () => (
    Platform.OS === 'web' ? (
        <svg xmlns="http://www.w3.org/2000/svg" width={15} height={15} viewBox="0 0 9.5 14.03">
            <title>moveDown</title>
            <g id="Layer_2">
                <g id="Layer_1-2">
                    <line x1="4.75" y1="0.75" x2="4.75" y2="13.28" style={styles.first} />
                    <line x1="4.75" y1="13.28" x2="8.75" y2="9.14" style={styles.first} />
                    <line x1="4.75" y1="13.28" x2="0.75" y2="9.14" style={styles.first} />
                </g>
            </g>
        </svg>
    ) : (<SvgXml xml={xml} />)
);

export default MoveDownIcon;
